<template>
    <div class="story-5">
        <div class="st-5-links">
            <ButtonWithImage :text="'25 LİTRE\nBELGESELİNİ İZLE'" :image="'25_litre@3x.png'" :link="'to:Documentary25Litre'"/>
            <ButtonWithImage :text="'SEN DE SÖZ VER'" :image="'promise.png'" :link="'waterPrintStart'"/>
        </div>
        <div class="st-5-social">
            <p>YARINIIN SUYU’NU TAKİP ET</p>
            <div class="st-5-s-links">
                <a href="https://www.instagram.com/yarininsuyu/" target="_blank">
                    <img src="@/assets/img/icons/iconfinder-38-instagram-1161954@3x.png" alt="Yarının suyu - Instagram">
                </a>
                <a href="https://www.youtube.com/finishturkiye" target="_blank">
                    <img src="@/assets/img/icons/iconfinder-58-youtube-104445@3x.png" alt="Yarının suyu - YouTube">
                </a>
                <a href="https://www.facebook.com/yarininsuyu" target="_blank">
                    <img src="@/assets/img/icons/facebook-2@3x.png" alt="Yarının suyu - Facebook">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "../main";
    import ButtonWithImage from "../components/ButtonWithImage";

    export default {
        name: "Story5",
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        },
        components: {
            ButtonWithImage
        }
    }
</script>

<style lang="scss">
    .story-5 {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: fixed;
        background-color: rgba(0,12,64,0.9);
        width: 100%;
        height: 100% !important;
        min-height: 100vh;
        min-width: 100vw;

        .st-5-links {
            display: flex;
            width: 80%;
            justify-content: space-evenly;
            margin-top: 10vh;
            flex-wrap: wrap;
            .overflowed-button {
                margin: 25px auto 25px auto;
                @media only screen and (max-device-width: 768px) {
                    .ob-image-container img {
                        object-fit: contain;
                    }
                    .ob-text-container {
                        width: calc(100% - 330px);
                    }
                }
            }
            @media only screen and (max-device-width: 768px) {
                width: 100%;
            }
        }

        .st-5-social {
            margin-top: 72px;

            p {
                font-size: 12px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
            }
            .st-5-s-links {
                display: flex;
                justify-content: space-evenly;
                margin-top: 27px;
                img {
                    width: 34px;
                    height: 34px;
                    object-fit: contain;
                }
            }
        }
    }



</style>
